import { backendBaseUrl } from "./config/api";

let API_BASE_URL = backendBaseUrl();

if (typeof window !== "undefined" && window.location.hostname === "localhost" && window.location.port === "3000") {
  // Prefer calling the local Apache server directly in CRA dev to avoid
  // proxy mismatches or missing server restarts during development.
  API_BASE_URL = "http://localhost/Ashoka/backend";
}

export async function loadPageSeo(route) {
  const url = `${API_BASE_URL}/seo-meta.php?route=${encodeURIComponent(route)}`;
  const response = await fetch(url, {
    credentials: "include",
    headers: { "Accept": "application/json" },
  });

  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await response.json().catch(() => ({}))
    : {};

  if (!response.ok || data.success === false) {
    throw new Error(data.message || "Unable to load SEO metadata.");
  }

  return data;
}
